import { effectType } from "./effect-type";
import { PropertyEffect } from "./component-property-effect";

export class Effect {
    public id: string = "temp-" + Math.floor(Date.now() / 1000);
    public sortOrderNumber: number = 0;
    public jsonDeterminants: string = "";
    public propertyEffects: PropertyEffect[] = [];
}
